export default {
	'main-info': 'Información principal',
	'mix-items': 'Mezclar artículos',
}